import { extractSequentialTaskProgressInfo } from '../task-progress/extract-sequential-task-progress-info';
import { extractNonSequentialTaskProgressInfo } from '../task-progress/extract-non-sequential-task-progress-info';
export function extractProcessTaskProgressInfo(nodeMap, progressMap, isSequential) {
    return isSequential
        ? extractSequentialTaskProgressInfo(nodeMap, progressMap)
        : extractNonSequentialTaskProgressInfo(nodeMap, progressMap);
}
